import React from 'react';
import { ModalBase, ModalHeader } from 'seduo-ui';
import classnames from 'classnames';
import { MODAL_TRANSITION_TIMEOUT, MODAL_BACKDROP_TRANSITION_TIMEOUT } from '../constants';
const Modal = ({ isOpen, size, toggle, backdrop, fade, wrapClassName, className, returnFocusAfterClose, children, withoutHeader, modalTransition, backdropTransition, }) => {
    return (<ModalBase isOpen={isOpen} size={size} toggle={toggle} backdrop={backdrop} fade={fade} wrapClassName={wrapClassName} returnFocusAfterClose={returnFocusAfterClose} className={classnames(className, {
            'modal-dialog--custom': !className,
        }, {
            'modal-dialog--without-header': withoutHeader,
        })} modalTransition={modalTransition} backdropTransition={backdropTransition}>
            {withoutHeader && <ModalHeader toggle={toggle}/>}
            {children}
        </ModalBase>);
};
Modal.defaultProps = {
    isOpen: false,
    size: null,
    toggle: null,
    className: null,
    backdrop: true,
    fade: true,
    returnFocusAfterClose: true,
    wrapClassName: '',
    withoutHeader: false,
    modalTransition: {
        timeout: MODAL_TRANSITION_TIMEOUT,
    },
    backdropTransition: {
        mountOnEnter: true,
        timeout: MODAL_BACKDROP_TRANSITION_TIMEOUT,
    },
};
export default Modal;
